/**
 * Utility functions for API calls and URL building
 */

/**
 * Build API URL based on environment
 * @param {string} endpoint - The API endpoint path
 * @returns {string} - Complete API URL
 */
export const buildApiUrl = (endpoint) => {
  const baseUrl = process.env.REACT_APP_NODE_ENV === 'dev'
    ? 'http://localhost:4242'
    : process.env.REACT_APP_BACKEND_URL;
  
  return `${baseUrl}${endpoint}`;
};

/**
 * Generic fetch wrapper with error handling
 * @param {string} url - The URL to fetch
 * @param {object} options - Fetch options
 * @returns {Promise} - Fetch response
 */
export const apiRequest = async (url, options = {}) => {
  try {
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status} ${response.statusText}`);
    }

    return response;
  } catch (error) {
    console.error('API request error:', error);
    throw error;
  }
};

/**
 * POST request helper
 * @param {string} endpoint - API endpoint
 * @param {object} data - Request body data
 * @returns {Promise} - Response JSON
 */
export const postRequest = async (endpoint, data) => {
  const url = buildApiUrl(endpoint);
  const response = await apiRequest(url, {
    method: 'POST',
    body: JSON.stringify(data),
  });
  return response.json();
};

/**
 * GET request helper
 * @param {string} endpoint - API endpoint
 * @returns {Promise} - Response JSON
 */
export const getRequest = async (endpoint) => {
  const url = buildApiUrl(endpoint);
  const response = await apiRequest(url, {
    method: 'GET',
  });
  return response.json();
};
